export const getOnlyNumbers = (s) => {
    if (s === undefined) {
        return -1;
    }
    if (typeof s !== "string") {
        s = s.toString();
    }
    const numberChars = s.replace(/\D/g, "");
    const number = parseInt(numberChars);
    if (isNaN(number)) {
        return -1;
    }
    else {
        return number;
    }
};
